import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@material-ui/core'
import { ControlledSlider } from '@v4/components/common/Slider'
import EditableHTML from '@v4/components/common/EditableHTML'
import PageMetaData from '@v4/utils/data/PageMetaData'
import clsx from 'clsx'
import EditableContainer from '@v4/components/common/EditableContainer'
import Item from './components/Item'
import { useTestimonial6 } from './Testimonial6.hooks'

const Testimonial6 = props => {
	const [
		{ classes, rounding, items, title, titleConfig, titleEditable, titleKey, sliderConfig },
		{ handleTitleClick, handleTitleChange },
	] = useTestimonial6(props)

	return (
		<div className="testimonial6">
			<div className="testimonial6-content">
				<EditableContainer
					visible={!!title}
					fieldConfig={titleConfig}
					onAdd={handleTitleChange}
					editable={titleEditable}
					wrapper={({ children }) => (
						<Grid container justify="center" className="testimonial6-title-container">
							<Grid item md={12}>
								<Box className={clsx(classes.title, 'testimonial6-title')}>{children}</Box>
							</Grid>
						</Grid>
					)}
				>
					<EditableHTML
						key={titleKey}
						className="testimonial6-text-block"
						gutterBottom
						html={title}
						onClick={handleTitleClick}
						editable={titleEditable}
						onChange={handleTitleChange}
					/>
				</EditableContainer>

				<ControlledSlider {...sliderConfig}>
					{_.map(items, (key, index) => (
						<Item key={key} group="items" itemKey={key} index={index} rounding={rounding} />
					))}
				</ControlledSlider>
			</div>
		</div>
	)
}

Testimonial6.propTypes = {
	metaData: PropTypes.shape({
		columns: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		title: PropTypes.instanceOf(PageMetaData),
		imageRounding: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default Testimonial6
